import React, { Suspense,useState } from 'react'
import ReactDOM from 'react-dom/client'
//import App from './App.jsx'
import './index.scss'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RecoilRoot,useRecoilValue } from "recoil";
// import Dashboard from './pages/dashboard.jsx'
// import PresentationServices from './pages/PresentationServices.jsx'
// import Help from './pages/help.jsx'
 import Login from "./pages/login";
import PresentationServices from "./pages/PresentationServices";

import Dashboard from "./pages/dashboard";
import { userDataState } from "./atoms/dashboard";
import Landing from "./pages/landing";
import NotFound from "./pages/NotFound";
import ExploreOpportunities from "./components/ExploreOpportunities/ExploreOpportunities";
import JourneyMap from "./pages/JourneyMap";
import { data } from "./utils/exploreoppdata";
import Help from "./pages/help";
import { MycarUrl } from './selectors/baseurl';
export const Loading = () => {
     const userData = useRecoilValue(userDataState);
//console.log("main root js",userData);
     // return <div className="loader mx-auto  mt-14 grid place-items-center">
     // </div>;
     return <div className="loader_outer"><div className="newloader"></div></div>;
   };
 export const RedPage=()=>{
  
window.location.href = MycarUrl;
 }  
function LoadPages(){
     //console.log("prasanna main jsx");
const userData = useRecoilValue(userDataState);
//console.log("main root js",userData);
     return (
          <>
            <BrowserRouter>
              <Routes>
                <Route index element={<Login />} />
                <Route path="dashboard" element={userData?.isLogged == false ? <RedPage /> : <Dashboard />} />
                <Route path="landing" element={userData?.isLogged == false ? <RedPage /> :<Landing />} />
                <Route path="carrerlattice" element={userData?.isLogged == false ? <RedPage /> :<PresentationServices />} />
                <Route
                  path="explore-roles"
                  element={userData?.isLogged == false ? <RedPage /> :<ExploreOpportunities isGridRow={true} data={data} isDetailsRequired={true} />}
                />
                <Route path="journey-map" element={userData?.isLogged == false ? <RedPage /> :<JourneyMap />} />
                <Route path="help" element={userData?.isLogged == false ? <RedPage /> :<Help />} />
                <Route path="*" element={<NotFound />} />
                  </Routes>
            </BrowserRouter>
        </>);
}
export default LoadPages;
